import React from 'react';
import Measure from 'react-measure';
//import {Grid, Row, Col} from 'react-bootstrap'
//import PieChart from 'react-simple-pie-chart';
import BudgetChart from './BudgetChart'
import _ from 'lodash'
import {receivers} from '../../constants'
import {colours as limitColours} from './BudgetStatus'

import {BarChart} from 'react-d3-basic'

const getLev = ((budgets, r) => ({
    ...(budgets[r] || {}),
    limit: receivers[r].limit
}))

export const calcWorstReceiver = (budgets) => {
    //const criteriaKeys = ['Ldn', 'Leq9', 'Leq15']//, 'Lmax']
    let worstReceiver, values
    if (budgets) {
        const firstReceiver = _.first(_.keys(receivers))
        values = getLev(budgets, firstReceiver)
        worstReceiver = receivers[firstReceiver]
        let minRemaining = values.remaining
        _.keys(receivers).forEach(r => {
            const levsForThisReceiver = getLev(budgets, r)
            //console.log('qq', r, levsForThisReceiver)
            if (/*levsForThisReceiver.limit.type !== 'Lmax' && */levsForThisReceiver.remaining < minRemaining) {
                minRemaining = levsForThisReceiver.remaining
                worstReceiver = receivers[r]
                values = levsForThisReceiver
            }
        })
    }

    //console.log('WORST receiver', worstReceiver, values)

    return {
        worstReceiver,
        values
    }
}

export const noiseBudgetBreached = (budget) => {
    if (!budget) {return false}
    const {values} = calcWorstReceiver((budget || {}).budgets)
    return (values || {}).remaining < 0
}

export const arrangeReceiversByDirection = (budgets) => {
    if (!budgets) {return}

    const worstInDirection = {
        North: 0,
        East: 0,
        West: 0,
        South: 0
    }
    _.keys(receivers).forEach(r => {
        const levsForThisReceiver = getLev(budgets, r)

        const used = (1 - levsForThisReceiver.remaining)
        //console.log('rr', r, levsForThisReceiver, receivers[r], receivers[r].direction, used)
        if (used > worstInDirection[receivers[r].direction]) {
            worstInDirection[receivers[r].direction] = used
        }
    })
    return worstInDirection
}

const BudgetView = ({budget}) => {

    const budgets = (budget || {}).budgets
    const {worstReceiver, values} = calcWorstReceiver(budgets)
    const worstInDirection = arrangeReceiversByDirection(budgets)
    const chartData = _.keys(worstInDirection).map(k => {
        return {
            text: k,
            value: worstInDirection[k]
        }
    })

    //console.log('BudgetView', budget, worstReceiver, values, 'WWW', worstInDirection)

    return (
        <div>

            <Measure>
                {dimensions => <div style={{paddingTop: '20px'}}>
                    {values && <BudgetChart dimensions={dimensions} values={values}/>}
                </div>}
            </Measure>

            {values && <div className="center-div worst-dir">{`${Math.round(1000 * (1 - values.remaining)) / 10}%`}</div>}

            {worstReceiver && <div className="center-div worst-dir">{`Heading with the least noise capacity available: ${worstReceiver.direction}`}</div>}
            {values.remaining <= (1 - limitColours.warning.value) && <div className="center-div worst-dir">Changing the EGR location is more likely to result in noise budget changes than changing the heading will.  Please edit your EGR to check for the effect on noise budget</div>}

            <Measure>
                {dimensions => <div>
                    <BarChart
                        title={"Noise Budget Use - by Area"}
                        data={chartData}
                        width={dimensions.width}
                        margins={{top: 30, right: 30, bottom: 40, left: 50}}
                        colors={d => 'ffff00'}
                        height={250}
                        showYGrid={false}
                        showXGrid={false}
                        showLegend={false}
                        chartSeries={[{field: 'value', name: '', color: '#3a4650'}]}
                        x={d => d.text}
                        xLabel={''}
                        xScale={'ordinal'}
                        yTicks={[10, "%"]}
                        yLabel={''}
                    />

                </div>
                }
            </Measure>


        </div>
    );
}

export default BudgetView






// WEBPACK FOOTER //
// ./src/components/budget/BudgetView.jsx